var map = {
	"./2026-05_introduction": "23e2",
	"./2026-05_introduction.yml": "23e2",
	"./active": "5448",
	"./active.yml": "5448",
	"./event-2026-09_ersti-special": "7f73",
	"./event-2026-09_ersti-special.yml": "7f73",
	"./event-2026-09_presale-started": "13c7",
	"./event-2026-09_presale-started.yml": "13c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e577";